import React, { useContext } from 'react';
import { Grid, CircularProgress } from '@material-ui/core';
import { getAgentFeaturePermissions, Agent } from '@moderepo/mode-internal-apis';
import { ritzDataContext, selectLoggedInAgent, selectProjectAgent, selectProjectById } from '@moderepo/mode-data-state-ritz';
import { capitalizeFirst, ITEMS_PER_PAGE_20 } from '@moderepo/mode-app-components';
import { useParams } from 'react-router-dom';
import { useRitzTranslation } from '../../utils/customHooks';
import { UsersListingContainer } from './UsersListingContainer';
import { NotAuthorized } from '../not-authorized/NotAuthorized';


/**
 * This is the page where we show all the project's users
 */
export const UsersListingPage: React.FC = () => {
    const params = useParams();
    const projectId = Number(params.projectId);
    const { state:dataState } = useContext(ritzDataContext);
    const loggedInAgent = selectLoggedInAgent(dataState) as Agent;
    const project = selectProjectById(dataState, projectId);
    const projectAgent = loggedInAgent ? selectProjectAgent(dataState, project?.id, loggedInAgent.id) : undefined;
    const { trans } = useRitzTranslation(project);
    const permissions = getAgentFeaturePermissions(projectAgent);



    if (!permissions.canViewUserProfile) {
        return (
            <NotAuthorized />
        );
    }

    return (
        <div className="page-main-content">
            {project ? (
                <>
                    <div className="title-bar">
                        <div className="title-bar-item title-text">
                            <div className="page-title">
                                {trans('page.title.user_listing')}
                            </div>
                            <div className="page-subtitle">
                                {capitalizeFirst(trans('page.subtitle.user_listing'))}
                            </div>
                        </div>
                    </div>

                    <Grid container spacing={3}>
                        {permissions.canLookupUsers && (
                            <Grid item xs={12}>
                                <UsersListingContainer
                                    projectId={project.id}
                                    itemsPerPage={ITEMS_PER_PAGE_20}
                                />
                            </Grid>
                        )}
                    </Grid>
                </>
            ) : (
                <CircularProgress />
            )}
        </div>
    );
};
